import {accounts529Type} from 'state/account/AccountSelectors';
import {createSelector} from "reselect";
import {legalReferenceNumbers} from 'services/Content';

export const getDerivedLegalReferenceNumber = createSelector(
  accounts529Type,
  (accountsType) => {
      if (accountsType.has529Only) {
    if (accountsType.hasNational529Only) {
      return legalReferenceNumbers.NATIONAL_ONLY_LRN;

    } else if (accountsType.hasAlaska529Only) {
      return legalReferenceNumbers.ALASKA_ONLY_LRN;
    } else if (accountsType.hasMaryland529Only) {
      return legalReferenceNumbers.MARYLAND_ONLY_LRN;
    } else {
      //I assume this will change with the 529 story
      return legalReferenceNumbers.AAM_NON_529_ONLY_LRN
    }
  } else {
    return legalReferenceNumbers.AAM_NON_529_ONLY_LRN;
  }
});